import { Col, Container, Row, Spinner } from "react-bootstrap";
import Header from "../../components/header"
import { BackButtonSignUp, ContainerSignUp, ContainerSignUpButtons, NextButtonSignUp, StyledInputSignUp, StyledSignUpText, StyledSignUpTextAdmin } from "../../components/renderField/styles";
import { CardEmployee } from "../welcome/styles";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { StyledBackButton, StyledBackButtonAdmin, StyledContainerButtons, StyledContainerLine, StyledContainerLineAdmin, StyledContainerParagraph, StyledLoginButton, StyledParagraph, StyledParagraphAdmin, StyledSwitchButton, StyledSwitchButtonAdmin } from "../signup/styles";
import { useToast } from "../../context/Toast";
import CustomCard from "../../components/customCard";
import PhoneInput from 'react-phone-number-input'
import ptBr from 'react-phone-number-input/locale/pt-BR.json'
import { StyledInputAdmin } from "./inputStyle";
import 'react-phone-number-input/style.css'
import { startCellphoneAuth } from "../../services/user/user";


import { useTranslation } from 'react-i18next';
const CellphoneAuthAdmin : React.FC = () =>{
    const { t } = useTranslation('auth');

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const {showToast} = useToast()

    const [phone, setPhone] = useState<any>(''); // Tipando o useState para string
    const [error, setError] = useState<string>(''); // Tipando o erro também como string

    // Função para validar o número de telefone
    const validatePhoneNumber = (): string | null => {
        if (!phone) {
            showToast(t('validation.phoneInvalid'), 'error')
            return null;
        }
        
        //adiciona o "+" ao DDI
        const formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;
        

        return formattedPhone; //retorna o número formatado
    };
    

    // Função chamada no envio do formulário
    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
        e.preventDefault();
        const formattedPhone = validatePhoneNumber();

        if (!formattedPhone || loading) return;
        setLoading(true);
        try {
            const authData = await startCellphoneAuth(formattedPhone);
            if (authData?.challengeName !== 'SMS_OTP' || typeof authData?.session !== 'string' || !authData.session) {
                showToast(t('errors.smsStart'), 'error', 8000);
                return;
            }
            showToast(t('verification.sent'), 'success', 6000);
            navigate('/admin/confirmation-code-auth', { state: { cellphone: formattedPhone, session: authData.session } });
        } catch (error: any) {
            if (error?.response?.status === 400) {
                showToast(t('validation.phoneInvalid'), 'error', 6000);
            } else if (error?.response?.status === 404) {
                showToast(t('errors.phoneNotFound'), 'error', 8000);
            } else if (error?.response?.status === 403) {
                showToast(t('errors.phoneUnauthorized'), 'info', 10000);
            } else {
                showToast(t('errors.generic'), 'error', 30000);
            }
        } finally {
            setLoading(false);
        }
    };
    

   
    return(
        <>
            <Container fluid className="d-flex h-100 mt-5 mb-2">
                <Row className="justify-content-center align-self-center w-100">
                    <Col md={9} lg={7}>
                        <CustomCard>
                            {loading ? (
                                <div className="d-flex align-items-center justify-content-center" style={{
                                    minHeight: '300px',

                                }}>
                                    <Spinner style={{ color: '#c9c9c9' }}></Spinner>
                                </div>
                            ) : (
                                <ContainerSignUp>
                                    <div className="d-flex justify-content-center flex-column ">
                                        <StyledSignUpTextAdmin>{t('signIn.phonePrompt')}</StyledSignUpTextAdmin>
                                        <div className="d-flex justify-content-center" 
                                            style={{
                                                width: '100%',
                                                flexDirection: 'column',
                                            }}>
                                        
                                            {/* <PhoneNumberInput 
                                                styleAdmin='admin'
                                                phone={phone}
                                                setPhone={setPhone} 
                                        
                                            /> */}

                                            <StyledInputAdmin
                                                placeholder={t('signIn.phonePlaceholder')}
                                                value={phone}
                                                onChange={setPhone}
                                                limitMaxLength={true}
                                                labels={ptBr}  
                                                defaultCountry="BR"
                                                className="input-admin"                         
                                            />
                                            {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}

                                        </div>
                                    </div>
                                    <StyledContainerParagraph>
                                        <StyledContainerLineAdmin></StyledContainerLineAdmin>
                                        <StyledParagraphAdmin>ou</StyledParagraphAdmin>
                                        <StyledContainerLineAdmin></StyledContainerLineAdmin>
                                    </StyledContainerParagraph>
                                    
                                    <StyledSwitchButtonAdmin onClick={() => navigate('/admin/signup')}>{t('signIn.switchToEmail')}</StyledSwitchButtonAdmin>
                                    <ContainerSignUpButtons>
                                        <StyledContainerButtons>
                                            <StyledBackButtonAdmin onClick={() => { navigate('/admin/signup') }} >{t('signIn.back')}</StyledBackButtonAdmin>
                                            
                                            <StyledLoginButton onClick={handleSubmit}> {t('signIn.submit')}</StyledLoginButton>
                                        </StyledContainerButtons>
                                        
                                    </ContainerSignUpButtons>
                                </ContainerSignUp>
                            )}
                        </CustomCard>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default CellphoneAuthAdmin;
